module.exports = __webpack_public_path__ + "img/icon_map_11_off_101.823f8626.png";